module.exports = "/images/img-3.png?ea5ce856569b352c351f5ca2dc278cb7";